import { useClearInferenceQueue } from "@/store";
import { useCallback } from "react";
import api from "@/utils/api";
import { useFlow } from "@/contexts/FlowContext";
import { useIsGeneratingPredictions } from "./useIsGeneratingPredictions";
import { useMedia } from "@/contexts/MediaContext";

export const useStopGeneratingPredictions = () => {
    const { setFlowLocked } = useFlow();
    const isGeneratingPredictions = useIsGeneratingPredictions();
    const clearInferenceQueue = useClearInferenceQueue();
    const { mediaItems } = useMedia();

    const stopGeneratingPredictions = useCallback(() => {
        if (!isGeneratingPredictions) return;

        // Abort the all active stream inferences
        for (const item of mediaItems) {
            const upload = item.uploadResizedResult || item.uploadResult;
            if (!upload?.filename) {
                throw new Error(`File ${item.file.name} not uploaded yet`);
            }

            api.inference.abortStreamInfer(upload.filename);
        }

        clearInferenceQueue();
        setFlowLocked(false);
    }, [mediaItems, clearInferenceQueue, setFlowLocked, isGeneratingPredictions]);

    return { stopGeneratingPredictions };
};
